import { useContext } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiContext } from '@shared/contexts';
import { TGetArchivedItemsResult } from '../types/archive.types';
import { ARCHIVE_ENDPOINT, ARCHIVE_QUERY_KEY } from '../constants';

export const useArchivedItems = ({ page, pageSize }: { page: number; pageSize: number }) => {
  const { apiClient, useHandleQueryError, retry } = useContext(ApiContext);

  const queryFn = async () => {
    if (!page || !pageSize) {
      // should not happen, but just in case
      console.warn('Page or pageSize is not provided. Returning empty archived items response.');
      return;
    }
    const { data } = await apiClient.get<TGetArchivedItemsResult>(ARCHIVE_ENDPOINT, {
      params: { page: page - 1, pageSize },
    });
    return data;
  };

  const isFirstPage = !page || page <= 1;
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [ARCHIVE_QUERY_KEY, page, pageSize],
    enabled: !!page && !!pageSize,
    queryFn,
    retry,
    refetchOnWindowFocus: isFirstPage,
    refetchOnReconnect: isFirstPage,
    placeholderData: keepPreviousData,
  });
  useHandleQueryError(isError, error, `Failed to load archived items on page ${page}!`);
  return { data, isLoading, error };
};
